/**
 * Reconnaît un VRAI échec de chargement de chunk/module Vite — et seulement
 * ça. L'ancien matcher acceptait les substrings `module`, `chunk`, `import`
 * et surtout `Failed to fetch` nus : n'importe quelle erreur réseau
 * transitoire (fréquente juste après un retour de background, quand la pile
 * réseau de la WebView se réveille) déclenchait un clearAppCaches + hard
 * reload… en pleine saisie. Les messages ci-dessous sont ceux réellement
 * émis par Vite/Webpack et les navigateurs pour un chunk manquant.
 */
const CHUNK_ERROR_PATTERNS: RegExp[] = [
  /failed to fetch dynamically imported module/i,
  /error loading dynamically imported module/i,
  /importing a module script failed/i,
  /loading chunk [\w-]+ failed/i,
  /chunkloaderror/i,
  /unable to preload css/i,
];

export function isChunkLoadError(message: string | undefined | null): boolean {
  if (!message) return false;
  return CHUNK_ERROR_PATTERNS.some((re) => re.test(message));
}
